import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'gipsy-ui'
import { styles } from 'gipsy-misc'
import { getSrc } from 'utils/image'

class EmptyContent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    hide: PropTypes.bool,
    children: PropTypes.element,
    style: PropTypes.object
  }

  static defaultProps = {
    hide: false
  }

  render() {
    const { title, subtitle, style } = this.props
    return (
      <Content className="content" hide={this.props.hide} style={style}>
        <Logo className="logo" src={getSrc('/images/gipsybot_thinking.svg')} alt="logo" />
        {title ? <Title className="title">{title}</Title> : ''}
        {subtitle ? <Message className="message">{subtitle}</Message> : ''}
        {this.props.children}
      </Content>
    )
  }
}

const Content = styled.div`
  display: ${props => (props.hide ? 'none !important' : 'flex')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 504px;
  margin-left: auto;
  margin-right: auto;
  ${media['phone-wide']`
    padding: 15px;  
  `}
  ${props => props.style}
`

const Logo = styled.img`
  height: 116px;
  width: 159px;
  margin-top: 100px;
  margin-bottom: ${styles.spacings.normal};
  ${media['phone-wide']`
    margin-top: 20px;
  `}
`

const Title = styled.div`
  color: ${styles.colors.textDarkColor};
  font-family: ${styles.fonts.primaryFont};
  font-size: ${styles.fonts.fontSize};
  line-height: ${styles.spacings.medium};
  margin-bottom: ${styles.spacings.normal};
  font-weight: 500;
  text-align: center;
`
const Message = styled.div`
  color: ${styles.colors.textLightColor};
  font-size: ${styles.fonts.fontSizeSmall};
  line-height: ${styles.spacings.medium};
  margin-bottom: ${styles.spacings.xsmall};
  text-align: center;
`

export default EmptyContent



// WEBPACK FOOTER //
// ./src/pages/teamlist/teamPage/emptyContent/index.js